import React, { useContext } from 'react';
import { CameraList, AddCamera, EditCamera } from "./";
import { CameraSection } from "../../context/CameraContext";
import { useTranslation } from "react-i18next";
import { FiCamera } from "react-icons/fi";

const CameraComp = () => {
    const { t } = useTranslation();
    const { cameraPage } = useContext(CameraSection);

    return (
        <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
            {cameraPage.firstPage && (
                <h2 className="setting-title">{t("دوربین‌ها")}</h2>
            )}
            {cameraPage.addCamera && (
                <h2 className="setting-title">{t("افزودن دوربین")}</h2>
            )}
            {cameraPage.editCamera && (
                <h2 className="setting-title">{t("ویرایش دوربین")}</h2>
            )}

            <div className="camera-content">
                {cameraPage.firstPage && <CameraList />}
                {cameraPage.addCamera && <AddCamera />}
                {cameraPage.editCamera && <EditCamera />}
            </div>
        </div>
    );
};

export { CameraComp };